import React, { useContext } from "react";
import { Box, IconButton, Typography } from "@mui/material";

import ClearIcon from "@mui/icons-material/Clear";
import theme from "../theme";
import AppContext from "../../context/AppContext";

const createStyles = () => ({
  productLabel: {
    paddingTop: "8px",
    paddingBottom: "8px",
    backgroundColor: theme.palette.primary.main + " !important",
    borderTopRightRadius: "100px",
    borderBottomRightRadius: "100px",
    color: "white",
    paddingLeft: "16px",
    height: "28px",
  },
  closeButton: {
    fontWeight: "bold",
    fontSize: "18px !important",
    color: "#232224",
    padding: "12px !important",
    width: "52px",
  },
  closeButtonNoRightPadding: {
    fontWeight: "bold",
    fontSize: "18px !important",
    color: "#232224",
    marginRight: "-12px",
    width: "52px",
  },
});

interface DialogBoxTitleProps {
  title: string;
  supplementaryTitle?: string;
  smallSupplementaryTitle?: boolean;
  width?: any;
  marginTop?: any;
  marginLeft?: any;
  paddingLeft?: any;
  closeButton?: boolean;
  closeButtonNoRightPadding?: boolean;
  handleClose?: () => void;
}

const DialogBoxTitle: React.FC<DialogBoxTitleProps> = (props) => {
  const classes = createStyles();
  const isDesktop = useContext(AppContext).isDesktop;

  return (
    <Box display="flex" justifyContent="space-between" align-content="strech" marginTop={props.marginTop}>
      <Box
        style={classes.productLabel}
        sx={[
          {
            height: props.smallSupplementaryTitle ? "auto !important" : "28px",
            paddingRight: props.smallSupplementaryTitle ? "30px" : "inherit",
            paddingLeft: props.paddingLeft ? `${props.paddingLeft} !important` : "inherit",
          },
          props.marginLeft !== undefined
            ? {
                marginLeft: props.marginLeft,
              }
            : {
                marginLeft: -4,
              },
        ]}
        width={props.width || 500}
        bgcolor="primary.main"
        py={1}
        mt={1}
        ml={-2}
      >
        <Typography variant={!isDesktop ? "body1" : props.title.length > 20 ? "h6" : "h4"}>
          <b>{props.title}</b>
          {props.smallSupplementaryTitle && <br />}
          <span style={{ fontSize: props.smallSupplementaryTitle ? "medium" : "inherit" }}>
            {props.supplementaryTitle}
          </span>
        </Typography>
      </Box>
      {props.closeButton && (
        <IconButton
          onClick={props.handleClose}
          data-testid="dialog-close"
          sx={props.closeButtonNoRightPadding ? classes.closeButtonNoRightPadding : classes.closeButton}
        >
          <ClearIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default DialogBoxTitle;
